import { Feature } from '@squareup/shared-types-protos/squareup/sub2/data';

export const SQUARE_ONE_PLAN_GROUP_TOKEN = 'square-one-group-v1' as const;
export const SQUARE_ONE_PLAN_TOKEN_FREE = 'square-one-free-v1' as const;
export const SQUARE_ONE_PLAN_TOKEN_PLUS = 'square-one-plus-v1' as const;
export const SQUARE_ONE_PLAN_TOKEN_PREMIUM = 'square-one-premium-v1' as const;

export enum TIER_TOKENS {
  FREE = 'free',
  PLUS = 'plus',
  PREMIUM = 'premium',
}

export const ALL_FEATURES = Object.values(Feature).filter((key: Feature | string) => typeof key !== 'string' && key !== Feature.DO_NOT_USE);
